<template>
  <FormSection title="Wachstumsziele">
    <template #text>
      Worin möchtest du dich als nächstes verbessern? Ändere deine Zielsetzungen und Prioritäten, nach denen ich meine Tipps gewichten soll.
    </template>
    <template #form>
      <ObjectiveForm :resource="resource" :errors="errors" />
    </template>
  </FormSection>
  <FormButtons>
    <div class="space-x-2">
      <BackButton />
      <SubmitButton @click="onSubmit" :load="updating" :success="success">
        Aktualisieren
      </SubmitButton>
    </div>
  </FormButtons>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useRetrieveResource } from '@/client/actions';
import { useUpdateResource } from '@/client/actions';

const store = useStore();
const router = useRouter();

const parent = computed(() => store.getters['context/context'].id);

const retrieveTarget = computed(() => '/api/podcasts/' + parent.value + '/objective');
const retrieveAction = useRetrieveResource(retrieveTarget);

const { retrieve, retrieving, resource } = retrieveAction;

const updateTarget = computed(() => '/api/podcasts/' + parent.value + '/objective');
const updateAction = useUpdateResource(updateTarget, resource);

const { update, updating, errors, message, success } = updateAction;

const onMount = onMounted(() => retrieve());
const onSuccess = () => null; // TODO
const onSubmit = () => update(onSuccess);
</script>
